import { FLAG_REGISTRY_DATA } from './flagRegistry.data.mjs'

export type DeployWorkflowId =
  | 'dev'
  | 'dev_mainnet'
  | 'dev_mainnet_wlth'
  | 'dev_wlth'
  | 'preprod'
  | 'preprod_wlth'
  | 'prod'
  | 'prod_wlth'
  | 'stage'
  | 'stage_wlth'

export type GardenerSeat = 'iain' | 'amer' | 'case'

export type FlagKind = 'boolean' | 'betaOnlyStrapi'

export type FlagDef = {
  kind: FlagKind
  env: `NEXT_PUBLIC_${string}`
  default: boolean
  owner: GardenerSeat
  allowedOn: readonly DeployWorkflowId[]
  retired?: boolean
}

export const FLAG_REGISTRY = FLAG_REGISTRY_DATA as Record<string, FlagDef>

export type FlagKey = keyof typeof FLAG_REGISTRY

function readFlagEnv(envName: string): string | undefined {
  const value = process.env[envName]
  if (value === undefined || value === '') {
    return undefined
  }
  return value
}

function parseBooleanEnv(raw: string | undefined, defaultValue: boolean): boolean {
  if (raw === undefined) {
    return defaultValue
  }
  return raw === 'true'
}

/** Strapi fund queries use "beta only" filtering when this returns true. */
export function betaOnlyStrapiFilterEnabled(): boolean {
  const def = FLAG_REGISTRY.betaOnlyStrapi
  const raw = readFlagEnv(def.env)
  if (raw === undefined) {
    return def.default
  }
  if (raw === 'false' || raw === '0') {
    return false
  }
  if (raw === 'true' || raw === '1') {
    return true
  }
  return def.default
}

export function isOn(key: FlagKey): boolean {
  const def = FLAG_REGISTRY[key]
  if (def.retired) {
    return true
  }
  if (def.kind === 'betaOnlyStrapi') {
    return betaOnlyStrapiFilterEnabled()
  }
  return parseBooleanEnv(readFlagEnv(def.env), def.default)
}
